import { render, staticRenderFns } from "./xhomeInfo.vue?vue&type=template&id=5bb91068&scoped=true&"
import script from "./xhomeInfo.vue?vue&type=script&lang=js&"
export * from "./xhomeInfo.vue?vue&type=script&lang=js&"
import style0 from "./xhomeInfo.vue?vue&type=style&index=0&id=5bb91068&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb91068",
  null
  
)

export default component.exports